import { useAuthStore } from '@/stores/auth';
import { useEffect } from 'react';

export const AuthCleanup = () => {
  const clearAuth = useAuthStore((state) => state.clearAuth);
  useEffect(() => {
    clearAuth();
  }, [clearAuth]);
  return null;
};
